import React from 'react';
import Layout from '@components/common/Layout';
import SettingIcon from '@assets/images/icon/ic-gnb-setting-24-blue-100@3x.png';

const Developing = () => {
  return (
    <Layout>
      <div className="developing">
        <div className="developing-image">
          <img src={SettingIcon} />
        </div>

        <div className="developing-title">개발중인 페이지 입니다.</div>
      </div>
    </Layout>
  );
};

export default Developing;
